"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getErrorsFromResponse;
const DEFAULT_ERROR = 'Une erreur imprévue est survenue, veuillez réessayer.';
function getErrorsFromResponse(_ref) {
  let {
    response = {},
    error
  } = _ref;
  error = error || DEFAULT_ERROR;
  let update = {
    loading: false,
    info: undefined,
    error: !(response !== null && response !== void 0 && response.warning) ? (response === null || response === void 0 ? void 0 : response.error) || error : undefined,
    warning: response === null || response === void 0 ? void 0 : response.warning,
    error_type: (response === null || response === void 0 ? void 0 : response.error_type) || undefined,
    status_messages: (response === null || response === void 0 ? void 0 : response.fields) || {}
  };
  return update;
}
